import { Entity } from "../helpers/Entity"

export type IntegrationConfigurationAttributes = {
    integrationKey: string,
    enabled: boolean,
    locationId?: string,
    locationIds?: string[],
    userId?: string,
    configuration: Configuration,
    enabledFeatures: EnabledFeatures,
    accountId: string,
    externalAccountId: string,
    secretKey?: string,
    publicKey?: string,
    testMode: boolean,
}

type EnabledFeatures = {
    [key: string]: boolean
}

//should be moved somewhere else
export type BasicConfiguration = {
    accountId: string
}
export type ConfigurationSquare = BasicConfiguration
export type ConfigurationWix = BasicConfiguration & {
    createQuoteOnFormSubmission: boolean,
    defaultInventoryLocationId: string
}
export type ConfigurationPipedrive = BasicConfiguration & {
    companyDomain: string
    userFullName: string
    externalUserId: string
    billingAddressFieldId: string
    shippingAddressFieldId: string
}
export type ConfigurationFreshbooks = BasicConfiguration & {
    businessId: string
    businessUuid: string
    //inventory location
    defaultInventoryLocationId: string
}

export type ConfigurationMailchimp = {
    accountId: string
    storeId: string
    listId: string
    apiEndpoint: string
}

export type ConfigurationZendeskSupport = {
    accountId: string
}

export type ConfigurationRainforest = BasicConfiguration
export type Configuration = object //todo define object type

export type IntegrationConfigurationDto = {
    id: string,
    type: string,
    attributes: IntegrationConfigurationAttributes,
}

export default class IntegrationConfiguration implements Entity {
    private id: string
    private type: string
    private attributes: IntegrationConfigurationAttributes
    constructor(dto: IntegrationConfigurationDto) {
        this.id = dto.id
        this.type = dto.type
        this.attributes = dto.attributes
    }

    isLoaded() {
        return this.id != "" && this.type == "integration-configurations"
    }

    getId() {
        return this.id
    }

    getExternalAccountId() {
        return this.attributes.externalAccountId
    }
}



// WEBPACK FOOTER //
// ./src/state/integration/IntegrationConfiguration.ts